<template>
  <div class="tab-pane active">
    <div class="responsive-table">
      <div class="loading min-h-300" v-if="loading">
        <LoadingAnim />
      </div>
      <table v-else class="table table-borderless">
        <thead class="">
          <tr>
            <th scope="col">{{ $tc('app.name', 1) }}</th>
            <!-- Data -->
            <th scope="col">{{ $t('app.created_at') }}</th>
            <!-- Tipo -->
            <th scope="col">{{ $t('app.sent_at') }}</th>
            <!-- Remetente -->
            <th scope="col">Status</th>
            <!-- Destinatario -->
            <th scope="col">{{ $tc('app.message', 2) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="campaign in campaigns"
            :key="campaign.id"
            :to="`history/${campaign.id}`"
          >
            <td data-label="Data">
              <div>
                <router-link :to="`history/${campaign.id}`">
                  {{ campaign.name }}
                </router-link>
              </div>
            </td>
            <td data-label="Tipo">
              {{ campaign.scheduled_at }}
            </td>
            <td data-label="Remetente">{{ campaign.sent_at }}</td>
            <td data-label="Status">
              <span
                v-if="campaign.status == 'accepted'"
                class="badge badge-light"
                >{{ $tc('generic-str.status.lbl-pending', 1) }}</span
              >
              <!-- Pendente -->
              <span
                v-else-if="campaign.status == 'queued'"
                class="badge badge-secondary"
                >{{ $t('generic-str.status.lbl-queue') }}</span
              >
              <!-- Em Fila -->
              <span
                v-else-if="campaign.status == 'sending'"
                class="badge badge-accent"
                >{{ $t('generic-str.status.lbl-sending') }}</span
              >
              <!-- Enviando -->
              <span
                v-else-if="campaign.status == 'sent'"
                class="badge badge-info"
                >{{ $t('generic-str.status.lbl-sent') }}</span
              >
              <!-- Enviado -->
              <span
                v-else-if="campaign.status == 'failed'"
                class="badge badge-danger"
                v-tooltip.top="
                  `${$t('sms.infos.filters.status.lbl-error')} ${
                    campaign.error_code
                  }: ${campaign.error_message}`
                "
                >{{ $tc('app.failed') }}</span
              >
              <!-- Falha -->
              <span
                v-else-if="campaign.status == 'delivered'"
                class="badge badge-success"
                >{{ $tc('app.delivered') }}</span
              >
              <!-- Entregue -->
              <span
                v-else-if="campaign.status == 'undelivered'"
                class="badge badge-dark"
                v-tooltip.top="
                  $t('generic-str.status.lbl-error') +
                  ` ${campaign.error_code}: ${campaign.error_message}`
                "
                >{{ $t('generic-str.status.lbl-unavailable') }}</span
              >
              <!-- Indisponivel -->
              <span
                v-else-if="campaign.status == 'received'"
                class="badge badge-success"
                >{{ $tc('generic-str.status.lbl-response', 1) }}</span
              >
              <!-- Resposta -->
            </td>
            <td data-label="Destinatário">{{ campaign.total_messages }}</td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <pagination :lastPage="pages" @change="fetch" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SmsService from '@/services/sms.service';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'SmsHistoryTab',
  components: {
    // PageHeader,
    Pagination,
  },
  props: {
    filters: {
      type: Object,
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      loading: true,
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Otu',
            'Nov',
            'Dez',
          ],
        },
      },
      fetched: true,
      campaigns: [],
      form: {
        id: '',
        status: '',
        from: '',
        to: '',
        scheduled_at: {
          gte: '',
          lte: '',
        },
        order_by: ['scheduled_at', 'desc'],
        page: 1,
      },
      pages: 1,
      exporting: false,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch(page = 1) {
      this.loading = true;

      this.$store
        .dispatch('fetchSmsCampaigns', {
          filter: {
            ...this.filters,
            scheduled_at: {
              gte: this.startDate,
              lt: this.endDate,
            },
          },
          page,
        })
        .then((response) => {
          this.campaigns = response.data;
          this.pages = response.last_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportData(format) {
      this.$store.dispatch('exportSmsMessages', {
        filter: this.filters,
        export: format,
      });
    },
    exportMessages() {
      this.exporting = true;
      SmsService.exportSms({
        filter: {
          id: this.form.id,
          from: this.form.from,
          to: this.form.to,
          status: this.form.status,
          sent_at: {
            from: this.beginDate,
            to: this.endDate,
          },
        },
      })
        .then(
          () => {
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('warnings.toast.report'),
              type: 'success',
            });
            this.$router.push('/sms/exports');
          },
          (error) => {
            this.$toast.show({
              title: this.$t('sms.infos.filters.status.lbl-error'),
              content: error.response.data.message,
              type: 'danger',
            });
          },
        )
        .finally(() => {
          this.exporting = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-search-id {
  height: 35px;
}
.btn-export {
  margin-left: 1px;
  padding: 8px 20px !important;
}
.m-top-10 {
  margin-top: 10px;
}

/* Rebranding */
.rebranding .card.borderless {
  box-shadow: unset !important;
}

.form-group {
  .icon_btn {
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid var(--form-border);
    border-left-color: transparent;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    span {
      color: var(--gray-font-color);
    }
  }
}
.darkmode .form-group .icon_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
  border-left-color: transparent;
}
.icon-success {
  color: #6eda2c;
}
.icon-failed {
  color: #ff0000;
}
</style>
